export default "__VITE_ASSET__BGcmK2oZ__"